export default __webpack_public_path__ + "static/media/10.68c7d8be.png";